// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.spacing80};
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
`;

const Section = styled.section`
  display: flex;
  align-items: center;
`;

const IMG = styled.div`
  background: ${({ theme }) => theme.colors.surface20};
  height: 48px;
  width: 48px;
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  margin-right: ${({ theme }) => theme.spacing.spacing40};
`;

const Item = styled.span<{ extended?: boolean; shrink?: boolean }>`
  display: inline-block;
  background: ${({ theme }) => theme.colors.surface20};
  height: ${({ shrink }) => (shrink ? '14px' : '20px')};
  width: ${({ extended }) => (extended ? '130px' : '100px')};
  margin-right: ${({ theme }) => theme.spacing.spacing40};
`;

function Placeholder() {
  return (
    <Wrapper data-test="reviewList-placeholder">
      <Section>
        <IMG />
        <div>
          <div>
            <Item />
            <Item />
          </div>
          <div>
            <Item shrink extended />
          </div>
        </div>
      </Section>
      <br />
      <Item shrink />
      <br />
      <Item shrink extended />
      <Item shrink extended />
      <Item shrink extended />
      <Item shrink extended />
      <Item shrink extended />
      <Item shrink extended />
    </Wrapper>
  );
}

export default memo(Placeholder);
